export default __webpack_public_path__ + "static/media/long-contact.79134ff8.png";